import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import http from '@/http/http';

const app = createApp(App);

app.config.globalProperties.$http = http;
app.use(router); // 确保 Vue Router 被正确挂载
app.mount('#app');
